import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CareersComponent } from './careers.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';


@NgModule({
  providers: [LanguageInterceptor],
  imports: [
    RouterModule.forChild([ // localeTag contains the string for i81n internationalization
      { path: ':language/careers', component: CareersComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'CAREERS_URL'}},
      { path: ':language/careers', component: CareersComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'CAREERS_URL'}},
      { path: ':language/careers', component: CareersComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'CAREERS_URL'}},
      { path: ':language/careers', component: CareersComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'CAREERS_URL'}},
      { path: ':language/careers', component: CareersComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'CAREERS_URL'}},
    ])
  ]
})
export class CareersRoutingModule { }
